import React, { useEffect, useState } from 'react';
import { Link, useParams } from 'react-router-dom';
import axios from 'axios';
import { API } from '@/config';
import Header from '@/components/layout/Header';
import Footer from '@/components/layout/Footer';
import { Button } from '@/components/ui/button';
import { mediaUrl } from '@/lib/mediaUrl';
import { BookOpen, Download, Loader2, XCircle } from 'lucide-react';

export default function EbookAccessPage() {
  const { token } = useParams();
  const [data, setData] = useState(null);
  useEffect(() => {
    axios.get(`${API}/hub/ebook/${token}`).then((r) => setData(r.data)).catch(() => setData({ error: true }));
  }, [token]);
  return (
    <div className="min-h-screen flex flex-col bg-[#F7F9FC]" data-testid="ebook-access-page">
      <Header />
      <main className="flex-1 max-w-lg w-full mx-auto px-4 py-14">
        <div className="bg-white rounded-2xl border border-slate-200 p-10 text-center">
          {!data ? <Loader2 className="h-10 w-10 animate-spin text-[#20acf6] mx-auto" /> : data.error ? (
            <>
              <XCircle className="h-12 w-12 text-red-500 mx-auto" />
              <h1 className="text-2xl font-bold text-[#2a3e5d] mt-4" data-testid="ebook-access-invalid">This link isn't valid</h1>
              <p className="text-sm text-slate-600 mt-2">Please use the link from your purchase email, or contact us and we'll help.</p>
              <Button asChild variant="outline" className="mt-6"><Link to="/knowledge-hub?tab=books">Back to e-books</Link></Button>
            </>
          ) : (
            <>
              {data.cover_url ? <img src={mediaUrl(data.cover_url)} alt={data.title} className="h-48 mx-auto rounded-md shadow-md object-cover" />
                : <div className="h-48 w-36 mx-auto rounded-md bg-[#2a3e5d] flex items-center justify-center"><BookOpen className="h-8 w-8 text-[#02d1d4]" /></div>}
              <h1 className="text-2xl font-bold text-[#2a3e5d] mt-6" data-testid="ebook-access-title">{data.title}</h1>
              {data.author && <p className="text-sm text-slate-500 mt-1">by {data.author}</p>}
              <Button asChild className="mt-6 bg-green-600 hover:bg-green-700">
                <a href={mediaUrl(data.file_url)} target="_blank" rel="noopener noreferrer" data-testid="ebook-access-download"><Download className="h-4 w-4 mr-2" />Download {data.format || 'e-book'}</a>
              </Button>
              <p className="text-xs text-slate-500 mt-4">Bookmark this page — this private link works whenever you need to download again.</p>
            </>
          )}
        </div>
      </main>
      <Footer />
    </div>
  );
}
